import React from 'react'

import * as S from './styles'

function BoxSkeleton ({ height }) {
  return <S.BoxSkeletonContainer height={height} />
}

export default BoxSkeleton
